import { CurrentUserState, UserAuthState } from '@app/storage'
import posthog from 'posthog-js'
import { UserAgentHelper } from '.'
import { AFFILIATE_LINK_INTERNAL_NAME_KEY, FOLLOW_TIPSTER_LINK_INTERNAL_NAME_KEY, INVITE_LINK_INTERNAL_NAME_KEY, INVITEE_TIPSTER_LINK_INTERNAL_NAME_KEY } from '@app/constants'

export const handleAuthEvents = (tracker, payload) => {
  const isGoogleAuth = payload?.data?.username?.startsWith('google_')
  const email = payload?.data?.signInUserSession?.idToken?.payload?.email
  // ONBOARDING DISABLED FOR TIPSTERIZER
  // const userType = localStorage.getItem('onboardingFlow')
  const userType = null

  if (payload.event === 'signIn' && isGoogleAuth) {
    tracker({
      variables: {
        email,
        sessionId: posthogGetDistinctId(),
        role: userType,
      },
    })
  }

  if (payload?.event === 'customOAuthState' && payload?.data) {
    try {
      const queryParams = decodeURIComponent(payload?.data)
      const param = JSON.parse(queryParams)
      Object.assign(UserAuthState, {
        affiliateLinkName: param?.[AFFILIATE_LINK_INTERNAL_NAME_KEY],
        inviteLinkName: param?.[INVITE_LINK_INTERNAL_NAME_KEY],
        followLinkName: param?.[FOLLOW_TIPSTER_LINK_INTERNAL_NAME_KEY],
        inviteeTipsterLinkName: param?.[INVITEE_TIPSTER_LINK_INTERNAL_NAME_KEY],
      })
    } catch (err) {
      console.error('OAuth state parse error', err)
    }
  }
}

export enum misc {
    FOOTBALL = 'Football',
    SOCCER = 'Soccer',
}

export const setAppHeight = () => {
  document.documentElement.style.setProperty('--app-height', `${window.innerHeight}px`)
}

export const checkWebpSupport = () => {
  UserAgentHelper.checkWebpSupport((result: boolean) => UserAuthState.webpSupported = result)
}

export enum currentView {
    POST_TIP = 'POST_TIP',
    POST_TIP_1 = 'POST_TIP_1',
    POST_TIP_2 = 'POST_TIP_2',
    POST_TIP_NON = 'POST_TIP_NON',
}

export enum currentViewTitle {
    CREATE_POST = 'Create Post',
    CREATE_POST_TIP_1 = 'Create Post Tip 1/2',
    CREATE_POST_TIP_2 = 'Create Post Tip 2/2',
    UPDATE_POST_TIP_1 = 'Update Post Tip 1/2',
    UPDATE_POST_TIP_2 = 'Update Post Tip 2/2',
    UPDATE_POST = 'Update Post',
}
export enum FIELD_CHECK {
    TITLE = 'title',
    SPORT_ID = 'sportId',
}
export enum PostTypes {
    REGULAR_POST = 'Regular_Post',
    SINGLE_POST_TIP = 'Single_PostTip',
    POST_TIP = 'Post_Tip',
}
export enum PostTipTypeEnum {
    Regular_Post = 'Regular_Post',
    Post_Tip = 'Post_Tip',
}
export enum PaymantTypeEnum {
    Automatic = 'Automatic',
    Manual = 'Manual',
}
export enum BookieTypeEnum {
    Custom_Odds = 'Custom_Odds',
    Verified_Odds = 'Verified_Odds',
}
export enum TipTypeEnum {
    Data_Tip = 'Data_Tip',
    Image_Tip = 'Image_Tip',
    OCR_Tip = 'OCR_Tip',
}

export enum UserTypeEnum {
    User = 'User',
    Tipster = 'Tipster',
}

export const changeSportNameToMatchIcon = (inputString)=> {
  const words = inputString?.split(' ')
  const camelCaseString = words?.map((word, index) => {
    if(word === 'Esports'){
      return 'eSports'
    }
    else if (index === 0) {
      return word.toLowerCase()
    } else {
      return word.charAt(0).toUpperCase() + word.slice(1)
    }
  }).join('')
  return camelCaseString
}

export const getAuthMethod = () => {
  return localStorage.getItem('auth_type') || CurrentUserState.auth_type
}

export const captureAnalytics = async (name: string, payload: {[key: string]: any}) => {
  posthog.capture(name, { ...payload, $groups: { tenant: window.location.hostname } })
}

export const aliasToUserId = ({ id }: {id: string}) => {
  posthog.alias(id)
}

/**
 * Identifies the current user in PostHog.
 * Should be called once after the user is loaded (on app init or after auth).
 * Uses the internal DB user ID as the distinct_id — never the email.
 * Email is stored as a person property so profiles remain searchable by email.
 * Safe to call multiple times: PostHog ignores re-identifies with the same ID.
 */
export const posthogIdentify = ({
  id,
  email,
  firstName,
  lastName,
  username,
}: {
  id: string
  email?: string | null
  firstName?: string | null
  lastName?: string | null
  username?: string | null
}) => {
  if (!id) return
  const name = [ firstName, lastName ].filter(Boolean).join(' ') || undefined
  posthog.identify(id, {
    ...(email ? { email } : {}),
    ...(name ? { name } : {}),
    ...(username ? { username } : {}),
  })
  posthog.group('tenant', window.location.hostname)
}

export const posthogGetDistinctId = (): string => {
  return posthog.get_distinct_id()
}

export  const fileExtensions = [ 'JPEG', 'PNG', 'SVG', 'WEBP', 'SVG+XML' ]
